import { useRecoilValue } from "recoil";
import { Stack } from "@mui/joy";
import PaymentButton from "components/PaymentButton2";
import TitleWithSubtitle from "components/common/TitleWithSubtitle";
import useSubscriptionStatus from "hooks/useSubscriptionStatus";
import ContentTemplate from "./ContentTemplate";
import { useTranslation } from "react-i18next";
import { isDev } from "config";
import { patientAtom } from "recoil/patientAtom";
import Reviews from "components/payment/Reviews";
import Keypoints from "components/payment/Keypoints";
import PromotionBanner from "components/payment/PromotionBanner";
import QnA from "components/payment/QnA";
import Positioning from "components/payment/Positioning";

export default function PaymentContent() {
  const patientState = useRecoilValue(patientAtom);

  const { t: t_payment } = useTranslation("translation", {
    keyPrefix: "payment",
  });
  const { hasFreeTrialUsed } = useSubscriptionStatus();

  const subtitle =
    !hasFreeTrialUsed || isDev
      ? t_payment("7일의 무료 체험 후 월 이용권이 자동으로 갱신됩니다.")
      : // t_payment("7일의 무료 체험 후 구독이 자동으로 시작됩니다.")
        undefined;

  return (
    <ContentTemplate>
      <Stack spacing={3}>
        <Stack spacing={"52px"}>
          <Stack spacing={3}>
            <TitleWithSubtitle
              title={t_payment("생각과 거리두고\n가치로 나아가세요")}
              subtitle={subtitle}
              titleLevel="h2"
              sx={{ textAlign: "center" }}
            />
            <PromotionBanner />
            <Keypoints />
          </Stack>
          <Reviews />
          <Stack spacing={3}>
            <TitleWithSubtitle
              title={t_payment("이제 당신 차례입니다", {
                nickname: patientState?.nickname,
              })}
              titleLevel="h3"
              sx={{
                textAlign: "center",
              }}
            />
            <Positioning />
            <QnA />
          </Stack>
        </Stack>
        <PromotionBanner />
        <PaymentButton />
      </Stack>
    </ContentTemplate>
  );
}
